<div class="notification-alert">
    <span class="header">
        Notificaciones
    </span>
    
    <div class="content">
        @if (annualRewardsAchieved) {
            <div class="card">
                <i class="pi pi-info-circle"></i>
                <div class="frame">
                    <h4>Tope anual de rewards alcanzado</h4>
                    <span>
                        Estimado socio, le informamos que ha alcanzado el limite anual de rewards para fin de semana (600/600) en la membresia de {{ getPortfolios(annualRewardsAchieved.portfolios) }}.
                    </span>
                    <p>{{ getTimeAgo(annualRewardsAchieved.date) }}</p>
                </div>
            </div>
        }
        
        @for (item of annualRewardsNearlyAchieved?.portfolios; track $index) {
            <div class="card">
                <i class="pi pi-info-circle"></i>
                <div class="frame">
                    <h4>Tope anual de rewards a punto de ser alcanzado</h4>
                    <span>
                        Estimado socio, le informamos que esta a punto de alcanzar el limite anual de rewards para fin de semana ({{ item.remaining }}/600) en la membresia de {{ getPortfolioName(item.id) }}.
                    </span>
                    <p>{{ getTimeAgo(annualRewardsNearlyAchieved.date) }}</p>
                </div>
            </div>
        }
    </div>
</div>
